import { http } from "@/lib/api";

/* --- the marketing site ----------------------------------------------------
   Separate from api.js on purpose: that file speaks about one wedding at a
   time and carries a per-wedding token. This one speaks about the site, and
   carries the owner's token — a different key for a different door. */

const unwrap = (promise) => promise.then((res) => res.data);

const STUDIO_TOKEN_KEY = "wsw-studio-token";

export const studioToken = () => localStorage.getItem(STUDIO_TOKEN_KEY) || "";
export const setStudioToken = (token) => localStorage.setItem(STUDIO_TOKEN_KEY, token);
export const clearStudioToken = () => localStorage.removeItem(STUDIO_TOKEN_KEY);

/** Auth header for the studio, attached per call rather than by an interceptor
    so a wedding request can never accidentally leave with the owner's key. */
const owner = () => ({ headers: { Authorization: `Bearer ${studioToken()}` } });

/* public ------------------------------------------------------------------ */

export const getSite = (lang) => unwrap(http.get("/site", { params: { lang } }));
export const listArticles = (params = {}) => unwrap(http.get("/site/articles", { params }));
export const getArticle = (slug) => unwrap(http.get(`/site/articles/${slug}`));
export const getSupport = (lang) => unwrap(http.get("/site/support", { params: { lang } }));
export const sendContact = (payload) => unwrap(http.post("/site/contact", payload));
export const studioStatus = () => unwrap(http.get("/site/status"));
export const studioLogin = (password) => unwrap(http.post("/site/login", { password }));

/* owner ------------------------------------------------------------------- */

export const getOwnerSite = () => unwrap(http.get("/studio/site", owner()));
export const patchSite = (patch) => unwrap(http.patch("/studio/site", patch, owner()));
export const getAnalytics = (days) =>
  unwrap(http.get("/studio/analytics", { ...owner(), params: { days } }));
export const getPlacements = () => unwrap(http.get("/studio/placements", owner()));
export const setStudioPassword = (currentPassword, newPassword) =>
  unwrap(
    http.post(
      "/studio/password",
      { current_password: currentPassword, new_password: newPassword },
      owner()
    )
  );

export const ownerArticles = (status) =>
  unwrap(http.get("/studio/articles", { ...owner(), params: status ? { status } : {} }));
export const ownerArticle = (id) => unwrap(http.get(`/studio/articles/${id}`, owner()));
export const createArticle = (payload) => unwrap(http.post("/studio/articles", payload, owner()));
export const updateArticle = (id, payload) =>
  unwrap(http.put(`/studio/articles/${id}`, payload, owner()));
export const deleteArticle = (id) => unwrap(http.delete(`/studio/articles/${id}`, owner()));
export const generateArticles = (brief) =>
  // writing takes the better part of a minute per language, and the shared
  // client's timeout is tuned for a plan, not for prose
  unwrap(http.post("/studio/articles/generate", brief, { ...owner(), timeout: 300000 }));
export const inspectVideo = (url) => unwrap(http.post("/studio/video/inspect", { url }, owner()));

export const ownerMessages = () => unwrap(http.get("/studio/messages", owner()));
export const setMessageHandled = (id, handled) =>
  unwrap(http.post(`/studio/messages/${id}/handled`, { handled }, owner()));
export const deleteMessage = (id) => unwrap(http.delete(`/studio/messages/${id}`, owner()));

export const ownerCampaigns = () => unwrap(http.get("/studio/campaigns", owner()));
export const generateCreative = (brief) =>
  unwrap(http.post("/studio/campaigns/generate", brief, { ...owner(), timeout: 180000 }));
export const saveCampaign = (payload) => unwrap(http.post("/studio/campaigns", payload, owner()));
export const removeCampaign = (id) => unwrap(http.delete(`/studio/campaigns/${id}`, owner()));
